<template>
  <div class="main">
    <media-header-con></media-header-con>
    <div class="main-header">
      <el-row :gutter="100" style="
          display: flex;
          justify-content: flex-end;
          padding: calc(100vw * 80 / 1920) calc(100vw * 40 / 1920) 0 calc(100vw * 40 / 1920);
        ">
        <el-col :lg="10" :sm="6" style="display: flex">
          <img @click="toIndex()" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_logo.png"
            style="width: calc(100vw * 300 / 1920); height: calc(100vw * 125 / 1920)" />
        </el-col>

        <el-col :lg="14" :sm="18" class="navbar">
          <div v-for="(item, index) in titles" :key="index" :class="item.selected ? 'title_selected' : ''" class="title"
            @click="toPage(item)">
            {{ item.title }}
          </div>
          <div class="title">
            <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: calc(100vw * 50 / 1920);
                height: calc(100vw * 50 / 1920);
                border-radius: 50%;
                background-color: #4063f9;
                margin-top: calc(100vw * -8 / 1920);
              ">
              <img src="../assets/icon/search.png" style="width: calc(100vw * 35 / 1920); height: calc(100vw * 35 / 1920)" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="media-768-main">
      <el-row class="main-Title" style="margin-top: calc(100vw * 60 / 1920); padding: 0 calc(100vw * 40 / 1920) 0 0;">
        <el-col :span="20" :offset="4" class="contact—lab">
          Bao Lab is one research group
        </el-col>
        <el-col :span="22" :offset="2" class="contact—lab">
          in Shenzhen Neher Neural Plasticity Lab
        </el-col>
      </el-row>

      <el-row class="media-768-mainTitle" style="margin-top:calc(100vw * 200 / 1920); padding: 0 calc(100vw * 40 / 1920) 0 0">
        <el-col :span="20" :offset="4" class="contact—lab"> Bao Lab </el-col>
        <el-col :span="22" :offset="2" class="contact—lab">
          is one research
        </el-col>
        <el-col :span="20" :offset="4" class="contact—lab">
          group in Shenzhen
        </el-col>
        <el-col :span="22" :offset="2" class="contact—lab">Neher Neural
        </el-col>
        <el-col :span="22" :offset="2" class="contact—lab">
          Plasticity Lab
        </el-col>
      </el-row>

      <el-row class="media-768-path" style="padding: 0 calc(100vw * 40 / 1920)">
        <div class="contact-path">

          <el-row :gutter="50">
            <!-- 左 -->
            <el-col class="media-768-Technology" :span="14" style="
                line-height: calc(100vw * 30 / 1920);
                font-size: calc(100vw * 18 / 1920);
                font-weight: bold;
                white-space: normal;
                text-align: left;
                color: #76787c;
              ">
              <el-row class="main-Technology">
                <el-col :span="24">
                  We are affiliated to the Brain Cognition and Brain Disease
                  Institute <a>http://bcbdi.siat.ac.cn/</a> of <br/>
                  Shenzhen Institutes of Advanced Technology, Chinese Academy of Science
                  <a>https://www.siat.ac.cn/</a>
                </el-col>
                <el-col :span="24" style="
                    margin-top: 50px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  ">
                  Find us in
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_finger.png"
                    style="margin-left: calc(100vw * 25 / 1920);width:calc(100vw * 30 /1920);height:calc(100vw * 30 /1920);" />
                </el-col>
              </el-row>

              <!--超出768尺寸时隐藏 -->
              <el-row class="media-768-hidden">
                <el-col :span="24" style="width: 100%;">
                  We are affiliated to the Brain Cognition and Brain Disease
                  Institute
                </el-col>
                <el-col :span="24"> <a>http://bcbdi.siat.ac.cn/</a> of </el-col>
                <el-col :span="24">
                  Shenzhen Institutes of Advanced Technology
                </el-col>
                <el-col :span="24">
                  <a>https://www.siat.ac.cn/</a>
                </el-col>

                <el-col class="meida-768-findUs" :span="24" style="
                    margin-top: calc(100vw * 50 / 1920);
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  ">
                  Find us in 22.59°N,113.99°E, Xue Yuan Da Dao 1068, Shenzhen, China
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_finger.png"
                    style="margin-left: calc(100vw * 25 / 1920);" />
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_media.png"
                    style="margin-left: calc(100vw * 25 / 1920);" />
                </el-col>
              </el-row>
            </el-col>



          </el-row>

            <!-- 右 -->
            <div class="main-image"  style="
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
              ">
              <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact-image.png" />
          </div>
        </div>
      </el-row>

      <div class="media-768-line">
        <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/line-radius.png" alt="" />
      </div>

      <el-row
        class="media-768-email"
        style="
          margin-top: calc(100vw * 20 / 1920);
          margin-bottom: calc(100vw * 40 / 1920);
          text-align: left;
          color: #2f3447;
          font-size: calc(100vw * 20 / 1920);
          font-weight: bold;
          line-height: calc(100vw * 25 / 1920);
        "
      >
        <div class="email-left">
          深圳市南山区西丽深圳大学城学苑大道1068号
          <br />邮编 : 518055
        </div>

        <div class="email-right">
          联系人 : 王彬又
          <br />email : by.wang2@siat.ac.cn
        </div>
      </el-row>

      <div class="media-768-img media-768-display">
        <div><img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact-image.png" alt=""></div>
        <div>
          <div><img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/labs/tang1.jpg" alt=""></div>
          <div><img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/labs/tang2.jpg" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mediaHeaderCon from './media/mediaHeaderCon';

export default {
  name: "Contactus",
  components: {
    mediaHeaderCon
  },
  data() {
    return {
      titles: [
        //'Research','People','Science And Art','Join Us','Contact Us'
        {
          title: "Research",
          key: "Research",
        },
        {
          title: "People",
          key: "People",
        },
        {
          title: "Science And Art",
          key: "Science",
        },
        {
          title: "Join us",
          key: "Joinus",
        },
        {
          title: "Contact us",
          key: "Contactus",
          selected: true,
        },
      ],
      current: 2,
    };
  },
  methods: {
    toPage(item) {
      this.$router.push(item.key);
    },
    toIndex() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>

.main {
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  text-rendering: optimizelegibility;
  min-height: 100vh;
  background: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_bg.png") no-repeat center center;
  background-size: cover;
  padding: 0 calc(100vw * 40 /1920);
}

.navbar {
  font-family: bahnschrift;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  cursor: pointer;
  letter-spacing: calc(100vw * -1 /1920);
}

.title {
  font-family: 'mon';
  font-size: calc(100vw * 28 / 1920);
  color: #4063f9;
  padding-top: calc(100vw * 10 / 1920);
  text-rendering: optimizelegibility;
  height: 100%;
}

.title > div {
  width: calc(100vw * 50 / 1920) !important;
  height: calc(100vw * 50 / 1920) !important;
}

.title img{
  width: 70% !important;
  height: 70% !important;
}

.title_selected {
  font-weight: bold;
  position: relative;
}

.title_selected::after {
  content: "__";
  color: #ff6a4a;
  font-weight: bold;
  position: absolute;
  left: calc(100vw * 10 / 1920);
  top: calc(100vw * 25 / 1920);
  font-size: calc(100vw * 25 / 1920);
}

.item {
  background-color: #ffffff;
  width: 15%;
  height: 65%;
  border: calc(100vw * 1 / 1920) solid #b4b4b4;
  margin: 0;
}

.selected {
  width: 20%;
  height: 75%;
  box-shadow: calc(100vw * 1 / 1920) calc(100vw * 1 / 1920) #b4b4b4;
}

.title_selected {
  font-weight: bold;
  position: relative;
}

.contact—lab {
  color: #333333;
  font-size: calc(100vw * 65 / 1920);
  font-weight: bold;
  text-align: right;
  line-height: calc(100vw * 100 / 1920);
}

.contact-path {
  padding: calc(100vw * 56 / 1920) 0;
  background: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_path.png") no-repeat;
  background-size: 100% 100%;
}

.contact-path img{
  margin-right: calc(100vw * 4 / 1920);
}

a {
  color: #5976f7;
}

.media-768-mainTitle {
  display: none;
}

.media-768-hidden {
  display: none;
}

.meida-768-findUs img:nth-child(2) {
  display: none;
}

/*当屏幕尺寸大于768px时，应用下面的CSS样式隐藏*/
.header-hidden {
  display: none;
}

.media-768-header {
  display: none;
}

.media-768-footer {
  display: none;
}

.media-768-line {
  display: none;
}

.media-768-display {
  display: none;
}

@media screen and (min-width: 769px) and (max-width: 1500px) {
  .contact—lab {
    font-size: calc(100vw * 48 / 1920) !important;
  }
  .title {
    font-size: 14px !important;
  }

  .main-header {
    padding: 0 20px;
  }

  .title_selected::after {
    bottom: 10px;
  }
}


@media screen and (min-width: 769px) and (max-width: 812px) {
  .contact—lab {
    font-size: calc(100vw * 30 / 1920) !important;
  }
}


/* 媒体查询 */
@media screen and (max-width: 768px) {
  img {
    width: 100%;
    height: 100%;
  }


  /* 在屏幕尺寸小于768时 CSS元素隐藏*/
  .main-header {
    display: none;
  }

  .media-768-display {
    display: flex;
  }
  .media-768-img > div:nth-child(1){
    width: 70%;
  }

  .media-768-img > div:nth-child(2){
    width: 30%;
    height: 50%;
  }

  .media-768-img > div img{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .main-image {
    display: none !important;
  }

  .el-footer {
    display: none;
  }

  .main-Title {
    display: none;
  }

  .main-Technology {
    display: none;
  }

  .main {
    background: #fff;
    padding: 0 !important;
  }


  .media-768-mainTitle {
    display: block;
    margin-top: 60px !important;
    padding: 0 !important;
    background-image: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/contact_bg.png");
    background-size: cover;
  }

  .media-768-mainTitle .el-col {
    font-size: 28px;
    line-height:55px;
    padding-right:32px;
  }

  .media-768-mainTitle>.el-col:first-child {
    margin-top: 40px;
  }

  .media-768-mainTitle>.el-col:last-child {
    margin-bottom: 25px;
  }

  /* 地址 */
  .contact-path {
    background: #fff;
    height: auto;
    padding: 40px 0;
  }

  .media-768-path {
    padding: 0 24px !important;
  }

  .media-768-Technology {
    width: 100%;
    font-size: 10px !important;
    line-height: 20px !important;
  }

  .media-768-hidden {
    display: block;
  }

  .meida-768-findUs {
    margin-top: 20px !important;
  }

  .meida-768-findUs img:nth-child(1) {
    display: none;
  }

  .meida-768-findUs img:nth-child(2) {
    display: block;
    width: 17px;
    height: 17px;
    margin-left: 17px!important;
  }

  .media-768-line {
    display: block;
    padding: 0 24px !important;
  }


}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .search_icon {
    width: calc(100vw * 32 / 1920) !important;
    height: calc(100vw * 32 / 1920) !important;
  }
  .title {
    font-size: calc(100vw * 28 / 1920) !important;
  }

  .title_selected::after {
    font-size: calc(100vw * 42 / 1920);
  }

  .main-image > img{
    width: 30% !important;
    height: auto !important;
  }

  .main-image > img:nth-child(3){
    width: 22% !important;
    height: calc(100vw * 300 / 1920) !important;
  }
  .contact-path {
    padding: calc(100vw * 128 / 1920) 0;
  }
}

@media screen and (min-width: 1200px) {
  .media-768-email {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    margin-top: calc(100vw * 20 / 1920);
    margin-bottom: calc(100vw * 40 / 1920);

    padding: 0;                 /* 关键：去掉左右挤压 */
    color: #2f3447;
    font-size: calc(100vw * 22 / 1920);  /* 稍微放大 */
    font-weight: bold;
    line-height: calc(100vw * 30 / 1920);
  }

  .email-left,
  .email-right {
    text-align: left;
  }
}


@media screen and (min-width: 3000px) {

  * {
    font-size: calc(100vw * 18 / 1920) !important;
    line-height: calc(100vw * 32 / 1920) !important;
  }

  .search_icon {
    width: calc(100vw * 28 / 1920) !important;
    height: calc(100vw * 28 / 1920) !important;
  }

  .title {
    font-size: calc(100vw * 28 / 1920) !important;
  }

  .title-icon {
    width: calc(100vw * 28 / 1920) !important;
    height: calc(100vw * 28 / 1920) !important;
  }

  .title_selected::after {
    font-size: calc(100vw * 28 / 1920) !important;
  }

  .contact—lab {
    font-size: calc(100vw * 54 / 1920) !important;
    line-height: calc(100vw * 74 / 1920) !important;
    padding-right: calc(100vw * 50 / 1920) !important;
  }

  .contact-path {
    margin-top: calc(100vw * 50 / 1920) !important;
  }

  .main-image > img{
    width: 30% !important;
    height: auto !important;
  }

  .main-image > img:nth-child(3){
    width: 22% !important;
    height: calc(100vw * 280 / 1920) !important;
  }
  .contact-path {
    padding: calc(100vw * 128 / 1920) 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Contactus.vue